import { z } from "zod";

const operationIdSchema = z.string().trim().min(1);
const metadataSchema = z.object({
  merchant_home_intent: z.object({ operation_id: operationIdSchema }),
});
const navigationStateSchema = z.object({
  merchantHomeIntent: z.object({ operationId: operationIdSchema }),
});

export function merchantHomeIntentOperationId(metadata: unknown, navigationState: unknown): string | null {
  const persisted = metadataSchema.safeParse(metadata);
  if (persisted.success) return persisted.data.merchant_home_intent.operation_id;
  const navigation = navigationStateSchema.safeParse(navigationState);
  return navigation.success ? navigation.data.merchantHomeIntent.operationId : null;
}
